import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
	loader: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
	spinner: {
		color: '#00e676',
	},
}));
